
import React from 'react';
import { FaEdit, FaTrash, FaVenusMars } from 'react-icons/fa';
import './SportsManagementStyle.scss';

const FacilityListTable = React.memo(({ facilities, openEditModal, openGenderModal, handleDelete }) => {
    return (
        <div className="table-responsive">
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Tesis Adı</th>
                        <th>Bölge</th>
                        <th>Tip</th>
                        <th>Kapasite</th>
                        <th>Temel Fiyat</th>
                        <th>Çalışma Saatleri</th>
                        <th>Kulüp</th>
                        <th>Durum</th>
                        <th>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {facilities.map((facility) => (
                        <tr key={facility.facilityId}>
                            <td>{facility.facilityName}</td>
                            <td>{facility.regionName}</td>
                            <td>
                                {facility.isSharedFacility ? (
                                    <span style={{ fontSize: '0.85rem', color: '#6366f1', fontWeight: '600' }}>
                                        Ortak Saha
                                    </span>
                                ) : (
                                    facility.typeName
                                )}
                            </td>
                            <td>{facility.capacity || '-'}</td>
                            <td>
                                {facility.isSharedFacility && facility.availableSports?.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        {facility.availableSports.map((sport, idx) => (
                                            <span key={idx} style={{ fontSize: '0.85rem' }}>
                                                <strong>{sport.typeName}:</strong> {sport.pricePerHour} ₺
                                            </span>
                                        ))}
                                    </div>
                                ) : (
                                    facility.paymentModel === 'Free' ? 'Ücretsiz' : facility.paymentModel === 'Credit' ? 'Kontör' : (facility.basePrice ? `${facility.basePrice} ₺` : '0 ₺')
                                )}
                            </td>
                            <td>{facility.workingHoursStart?.substring(0, 5)} - {facility.workingHoursEnd?.substring(0, 5)}</td>
                            <td>
                                {facility.allowClubReservations ? (
                                    <span style={{ color: 'green', fontSize: '0.85rem' }}>
                                        Açık ({facility.clubPricePerPerson} ₺/kişi)
                                    </span>
                                ) : (
                                    <span style={{ color: '#ccc', fontSize: '0.85rem' }}>Kapalı</span>
                                )}
                            </td>
                            <td>
                                <span className={`status-badge ${facility.isActive ? 'active' : 'inactive'}`}>
                                    {facility.isActive ? 'Aktif' : 'Pasif'}
                                </span>
                            </td>
                            <td className="actions-cell">
                                <div className="action-buttons-wrapper">
                                    <button className="btn-premium btn-sm btn-info" onClick={() => openGenderModal(facility)} title="Cinsiyet Kısıtlamaları">
                                        <FaVenusMars />
                                    </button>
                                    <button className="btn-premium btn-sm btn-outline" onClick={() => openEditModal(facility)}>
                                        <FaEdit /> Düzenle
                                    </button>
                                    <button className="btn-premium btn-sm btn-danger" onClick={() => handleDelete(facility.facilityId)}>
                                        <FaTrash /> Sil
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {facilities.length === 0 && (
                        <tr>
                            <td colSpan="9" className="text-center">Kayıt bulunamadı.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
});

export default FacilityListTable;
